//
//
//
//
//
//
//

import StepDescription6000 from './components/stepDescription6000.vue'
import StepDescription7000 from './components/stepDescription7000.vue'
import axios from 'axios'

export default {
    components:{
        StepDescription6000,
        StepDescription7000
    },
    data () {
        return {
            productCode: ''
        }
    },
   created(){
     this.getProductCodeFun();
   },
    methods:{
        getProductCodeFun(){
             let url =  process.env.BASE_API2 +'getProductCode'
            axios({
                method: 'post',
                url: url,
                data: {}
            }).then((res)=>{
                 if(res.data.responseCode === '000000'){
                    this.productCode = res.data.responseData.productCode;
                    localStorage.setItem('productCode',this.productCode)
                 }
              
            })
        }
    }
   
}



// WEBPACK FOOTER //
// ./src/view/stepDescription.vue